import { IInfrastructureTypeResponse } from 'shared/common/repositories/infrastructure-caching/entities/infrastructure/InfrastructureTypeResponse';

import { IInfrastructureType } from '../../types/infrastructure';

export function prepareInfrastructureTypes(response: IInfrastructureTypeResponse): IInfrastructureType[] {
  const layers: IInfrastructureType[] = [];
  for (const layer of response.types) {
    if (layer.drawType === 'pin') {
      // oxlint-disable-next-line typescript/no-unused-vars
      const { drawType, ...rest } = layer;
      layers.push(rest);
    }
  }

  return layers;
}
